import NProgress from 'nprogress'
import { useEffect } from 'react'

export const useNProgress = (...waitOn: boolean[]) => {
  useEffect(() => {
    if (waitOn.some((loading) => loading)) {
      NProgress.start()
    } else {
      NProgress.done()
    }

    return () => {
      NProgress.done()
    }
  }, [waitOn])

  return null
}
